import React, { useState } from 'react';
import noop from 'lodash/noop';
import Button from 'ui/Button';

import BetConfirm from './BetConfirm';

const BuyCoupon = ({ coupon, validCoupon, pool, refetchPoolDetails }) => {
    const [showConfirm, setShowConfirm] = useState(false);

    return (
        <>
            <BetConfirm
                title={'Bekræft køb'}
                isOpen={showConfirm}
                onClose={() => setShowConfirm(false)}
                groupName={pool?.poolTemplate?.name}
                coupon={coupon}
                pool={pool}
                refetchPoolDetails={refetchPoolDetails}
            />
            <Button
                active
                className="flex-grow"
                margin={'10px 0 10px 10px'}
                disabled={!validCoupon}
                onClick={validCoupon ? () => setShowConfirm(true) : noop}
            >
                Køb kupon
            </Button>
        </>
    );
};

export default BuyCoupon;
